import React, { useEffect,useContext,useState } from "react";
import Context from '../context/context';
import helpers from '../_helpers/helpersFunction'
import Lang from '../lang/translations';

export default function InputAuto(props) {

  

    const [suggestions, setSugesstions] = useState([]);
    const [isHideSuggs, setIsHideSuggs] = useState(true);
    const [selectedVal, setSelectedVal] = useState("");
    const [data, setData] = useState({});
    
    const context = useContext(Context)

    useEffect(() => { 
        helpers.getCitiesByCountry().then(cities => {
            setData(cities)
        })
        
	
	  },[]);

    

    const handler = e => {
      if(data.length > 0){
          const res = data.filter(i => {
            return i.city_title.toLowerCase().startsWith(selectedVal)
          })
          setSugesstions(res);
      }
    };
  
    const handleChange = e => {
      const input = e.target.value;
      setIsHideSuggs(false);
      setSelectedVal(input.toLowerCase());
      onChange(input);
      
    };
  
    const hideSuggs = value => {
      onSelected(value);
      setSelectedVal(value.city_title );
      setIsHideSuggs(true);
   
    };

 


    const onSelected = value => {
        context.setSearchCity(value.city_title)
        context.setSearchRegion(value.state_title)
      //context.user_form.city_id = value.city_id
        
      updateUserLocation(value.state_title,value.city_title).then((user)=>{
        props.onChange(user)
        //const seme = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        //helpers.set_seme(seme, context);
      })
      setIsHideSuggs(true);
      
    };
  
    const onChange = value => {
      if(value == ""){
        context.searchCity = null
        //context.user_form.city_id = null
        context.searchRegion = null
        setIsHideSuggs(true);
      }

      
    };

    async function updateUserLocation(region,city){

        var token = localStorage.getItem('token')
		var trackerId = localStorage.getItem('trackerId')

      return await fetch(process.env.REACT_APP_APIADDRESS+"/users/"+trackerId, {
			method: 'put',
			headers: {
			  'Accept': 'application/json, text/plain, */*',
			  'Content-Type': 'application/json',
			  'Authorization': 'Bearer '+ token
			},
			body: JSON.stringify({region:region,city:city, ...(props.extraData || {})})
			})
			.then(response => response.json()) 
			.then(res => {

        if(res.result){
          return res.user
        }
      })
    }


  
    return (
      <div className="sugesstion-auto">
        <div className="form-control-auto">
          <input
            placeholder={"📍 "+context.user_info.city}
            type="search"
            value={selectedVal}
            onChange={handleChange}
            onKeyUp={handler}
            className="inputCity"
            name="citta"
          />
        </div>
  
        <div className="suggestions" style={{ display: isHideSuggs ? "none" : "inline-block" , cursor: "pointer"}}
        >
          {suggestions.map((item, idx) => (
            <div
              key={"" + item.city_title + idx}
              onClick={() => {
                hideSuggs(item);
              }}
            >
              {item.city_title}
            </div>
          ))}
        </div>
        { props.city && (<div className="errore">Errore</div>)}
      </div>
    );
  }